(() => {
  const endpoint = '/apps/offer-progress';
  let request;

  const mounts = () => [...document.querySelectorAll('[data-auto-offer-progress]')];
  const destroySlider = (mount) => {
    const slider = window.Flickity?.data(mount);
    if (slider) slider.destroy();
  };
  const hide = () => mounts().forEach((mount) => {
    destroySlider(mount);
    mount.hidden = true;
    mount.replaceChildren();
  });

  const money = (amount, currencyCode) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: currencyCode
  }).format(amount);

  const cartAmount = (minorUnits, currencyCode) => {
    const digits = new Intl.NumberFormat('en', { style: 'currency', currency: currencyCode })
      .resolvedOptions().maximumFractionDigits;
    return Number(minorUnits) / (10 ** digits);
  };

  function render(offers) {
    const triggeredOffers = offers.filter((offer) => offer.current > 0);
    if (!triggeredOffers.length) return hide();
    mounts().forEach((mount) => {
      destroySlider(mount);
      mount.hidden = false;
      mount.replaceChildren();
      triggeredOffers.forEach((offer) => {
        const current = Math.min(offer.current, offer.required);
        const complete = offer.remaining <= 0;
        const progress = Math.min(100, Math.round((current / offer.required) * 100));
        const content = document.createElement('div');
        content.className = 'auto-offer-progress__content auto-offer-progress__slide';
        const row = document.createElement('div');
        row.className = 'auto-offer-progress__row';
        const message = document.createElement('p');
        message.className = 'auto-offer-progress__message';
        message.append(complete
          ? mount.dataset.offerProgressQualifies
          : offer.progressType === 'amount'
            ? `Spend ${money(offer.remaining, offer.currencyCode)} more to enjoy `
            : mount.dataset.offerProgressAddMore.replace('__COUNT__', offer.remaining));
        const title = document.createElement('strong');
        title.textContent = offer.title;
        message.append(title);
        const count = document.createElement('span');
        count.className = 'auto-offer-progress__count';
        count.textContent = offer.progressType === 'amount'
          ? `${money(current, offer.currencyCode)}/${money(offer.required, offer.currencyCode)}`
          : `${current}/${offer.required}`;
        row.append(message, count);

        const track = document.createElement('div');
        track.className = 'auto-offer-progress__track';
        track.setAttribute('role', 'progressbar');
        track.setAttribute('aria-valuemin', '0');
        track.setAttribute('aria-valuemax', String(offer.required));
        track.setAttribute('aria-valuenow', String(current));
        const fill = document.createElement('div');
        fill.className = 'auto-offer-progress__fill';
        fill.style.width = `${progress}%`;
        track.append(fill);

        const link = document.createElement('a');
        link.className = 'auto-offer-progress__link';
        link.href = offer.shopNowUrl;
        link.textContent = mount.dataset.offerProgressShopNow;
        content.append(row, track, link);
        mount.append(content);
      });

      if (triggeredOffers.length > 1 && window.Flickity) {
        mount.setAttribute('aria-label', 'Offer progress');
        new window.Flickity(mount, {
          adaptiveHeight: true,
          autoPlay: 5000,
          cellAlign: 'left',
          contain: true,
          draggable: true,
          pageDots: true,
          pauseAutoPlayOnHover: true,
          prevNextButtons: true,
          wrapAround: true
        });
      } else {
        mount.removeAttribute('aria-label');
      }
    });
  }

  async function refresh() {
    if (!mounts().length || request) return request;
    request = (async () => {
      try {
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.ok ? response.json() : Promise.reject());
        if (!cart.items?.length) return hide();
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            currencyCode: cart.currency,
            subtotal: cartAmount(cart.items_subtotal_price, cart.currency),
            items: cart.items.map((item) => ({
              productId: item.product_id,
              variantId: item.variant_id,
              quantity: item.quantity,
              lineSubtotal: cartAmount(item.final_line_price, cart.currency)
            }))
          })
        });
        const payload = response.ok ? await response.json() : null;
        const offers = Array.isArray(payload?.offers) ? payload.offers : payload?.offer ? [payload.offer] : [];
        render(offers);
      } catch (_) {
        hide();
      } finally {
        request = null;
      }
    })();
    return request;
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('cart-drawer:open', refresh);
  document.addEventListener('line-item:change:end', () => window.setTimeout(refresh));
  document.addEventListener('cart:refresh', () => window.setTimeout(refresh));
})();
